export default {
      id: "bell-usage",
      viewBox: "0 0 15 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#bell",
      toString: function () {
        return this.url;
      }
    }